import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'power-dms-logo-icon',
  templateUrl: './power-dms-logo-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PowerDmsLogoIconComponent {}
